import Vue from 'vue';
import VueIp from 'vue-ip';

Vue.use(VueIp);
